import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { repositoriesKeys } from './repositoriesKeys';

type TParams = QueryFunctionContext<ReturnType<typeof repositoriesKeys.list>>;

export const createFetchOrganizationRepositoriesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        OrganizationsService.getOrgRepos({
          oid: organizationId,
          orderBy: 'name',
          orderType: 'asc',
          search: params.search,
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          from: params.from,
          to: params.to,
        }),
        signal,
      ),
    );
